import { createContext, useContext } from "react"

// Keep context identity separate from components replaced by Fast Refresh.
export const SidebarContext = createContext<{
	state: "expanded" | "collapsed"
	open: boolean
	setOpen: (open: boolean) => void
	openMobile: boolean
	setOpenMobile: (open: boolean) => void
	isMobile: boolean
	toggleSidebar: () => void
} | null>(null)

export function useSidebar() {
	const context = useContext(SidebarContext)
	if (!context) {
		throw new Error("useSidebar must be used within a SidebarProvider.")
	}

	return context
}
